/**
 * True on touch-first devices where read-aloud should play on a single tap
 * rather than opening a popover with separate transport controls.
 */
export function prefersSingleTapPlayback(): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(pointer: coarse)').matches;
}
